// extracted by mini-css-extract-plugin
export default {"container":"download_container__3hkgz","image":"download_image__2k22D","inner":"download_inner__2Xfmr","withImage":"download_withImage__24Y6I","icon":"download_icon__138Nt"};